<template>
  <div class="fac-dash">
    <header class="fac-dash__page-head">
      <div class="fac-dash__page-head-text">
        <h1 class="fac-dash__page-title">품질·불량</h1>
        <!-- <p class="fac-dash__page-sub">
          불량 유형·라인별 NG·검사 추이 등 지표를 한 화면에서 확인합니다.
        </p> -->
      </div>
      <div class="fac-dash__page-head-actions">
        <el-date-picker
          v-model="periodRange"
          type="daterange"
          unlink-panels
          range-separator="~"
          start-placeholder="시작일"
          end-placeholder="종료일"
          value-format="yyyy-MM-dd"
          format="yyyy.MM.dd"
          size="small"
          class="fac-dash__period"
          :picker-options="periodPickerOptions"
          @change="onPeriodChange"
        />
        <el-button
          type="default"
          size="small"
          icon="el-icon-download"
          class="fac-dash__head-btn"
          @click="onDemoExport"
        >
          내보내기
        </el-button>
        <el-tooltip content="데이터를 다시 불러옵니다" placement="bottom">
          <el-button
            type="default"
            size="small"
            icon="el-icon-refresh"
            circle
            class="fac-dash__refresh"
            @click="onRefresh"
          />
        </el-tooltip>
      </div>
    </header>

    <section class="fac-dash__kpis">
      <el-card
        v-for="item in kpis"
        :key="item.key"
        class="fac-dash__kpi-card"
        shadow="hover"
      >
        <p class="fac-dash__kpi-label">{{ item.label }}</p>
        <p class="fac-dash__kpi-value">{{ item.value }}</p>
        <p class="fac-dash__kpi-meta">{{ item.meta }}</p>
      </el-card>
    </section>

    <el-row :gutter="20" class="fac-dash__row">
      <el-col :xs="24" :lg="14">
        <el-card class="fac-dash__chart-card" shadow="never">
          <div slot="header" class="fac-dash__card-head">
            <span>불량 유형 Pareto (건수)</span>
          </div>
          <apexchart
            :key="'pareto-' + chartRevision"
            type="bar"
            height="300"
            :options="paretoOptions"
            :series="paretoSeries"
          />
        </el-card>
      </el-col>
      <el-col :xs="24" :lg="10">
        <el-card class="fac-dash__chart-card" shadow="never">
          <div slot="header" class="fac-dash__card-head">
            <span>라인별 불량 비중</span>
          </div>
          <apexchart
            :key="'line-ng-' + chartRevision"
            type="donut"
            height="300"
            :options="lineDonutOptions"
            :series="lineDonutSeries"
          />
        </el-card>
      </el-col>
    </el-row>

    <!-- <el-row :gutter="20" class="fac-dash__row">
      <el-col :xs="24">
        <el-card class="fac-dash__chart-card" shadow="never">
          <div slot="header" class="fac-dash__card-head">
            <span>불량 판정 요인 기여</span>
          </div>
          <p class="fac-dash__xai-legend">
            <span class="fac-dash__xai-legend-item"
              ><i class="fac-dash__xai-dot is-up" />불량 확률 상승 기여</span
            >
            <span class="fac-dash__xai-legend-item"
              ><i class="fac-dash__xai-dot is-down" />완화·정상 쪽 기여</span
            >
          </p>
          <apexchart
            :key="'xai-' + chartRevision"
            type="rangeBar"
            height="360"
            :options="xaiOptions"
            :series="xaiSeries"
          />
        </el-card>
      </el-col>
    </el-row> -->

    <el-row :gutter="20" class="fac-dash__row">
      <el-col :xs="24">
        <el-card class="fac-dash__chart-card" shadow="never">
          <div slot="header" class="fac-dash__card-head">
            <span>공정 불량률 추이</span>
            <span class="fac-dash__card-head-meta">{{ trendPeriodHint }}</span>
          </div>
          <apexchart
            :key="'trend-' + chartRevision"
            type="area"
            height="280"
            :options="trendOptions"
            :series="trendSeries"
          />
        </el-card>
      </el-col>
    </el-row>

    <el-row :gutter="20" class="fac-dash__row">
      <el-col :xs="24">
        <el-card class="fac-dash__chart-card" shadow="never">
          <div slot="header" class="fac-dash__card-head">
            <span>선택 기간 불량 LOT</span>
          </div>
          <el-table :data="lotRows" stripe size="small" class="fac-dash__table">
            <el-table-column prop="time" label="일시" min-width="128" />
            <el-table-column prop="line" label="라인" width="72" />
            <el-table-column prop="lot" label="LOT" width="120" />
            <el-table-column prop="type" label="유형" width="100" />
            <el-table-column
              prop="qty"
              label="불량수"
              width="88"
              align="right"
            />
            <el-table-column prop="cause" label="조치" min-width="180" />
          </el-table>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
const PRIMARY = "#254aa5";
const PRIMARY_LIGHT = "#4a90e2";
const MUTED = "#8b95a5";

const DEFECT_LABELS = ["스크래치", "치수 NG", "이물", "색상", "기타"];

function parseYmd(s) {
  const [y, m, d] = s.split("-").map(Number);
  return new Date(y, m - 1, d);
}

function daysInclusive(startStr, endStr) {
  const a = parseYmd(startStr);
  const b = parseYmd(endStr);
  const diff = Math.round((b - a) / 86400000) + 1;
  return Math.max(1, diff);
}

function hashPeriod(startStr, endStr) {
  const s = `${startStr}|${endStr}`;
  let h = 0;
  for (let i = 0; i < s.length; i += 1) {
    h = (h * 31 + s.charCodeAt(i)) >>> 0;
  }
  return h % 997;
}

function defaultPeriodRange() {
  const end = new Date();
  const start = new Date(end);
  start.setDate(start.getDate() - 13);
  const fmt = (d) => {
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${y}-${m}-${day}`;
  };
  return [fmt(start), fmt(end)];
}

function buildTrend(seed, startStr, dayCount) {
  const start = parseYmd(startStr);
  const labels = Array.from({ length: dayCount }, (_, i) => {
    const d = new Date(start);
    d.setDate(d.getDate() + i);
    return `${d.getMonth() + 1}/${d.getDate()}`;
  });
  const n = Math.max(dayCount, 1);
  const data = labels.map((_, i) => {
    const base = 0.35 + (seed % 20) / 200;
    return Number(
      (
        base +
        Math.sin((i / n) * Math.PI * 2) * 0.12 +
        ((i * 3 + seed) % 7) / 400
      ).toFixed(2)
    );
  });
  return { labels, data };
}

/** XAI 스타일: 구간 [low, high] + 불량 쪽 기여(붉색) / 완화(청색) 데모 */
function buildXaiData(seed) {
  const j = (a, b) => a + ((seed * 13) % (b - a + 1));
  const mk = (label, lo, hi, neg) => {
    const a = Math.max(22, lo + j(0, 12));
    const b = Math.min(142, Math.max(a + 8, hi + j(0, 15)));
    const fillColor = neg ? "#e85d6f" : "#254aa5";
    return {
      x: label,
      y: [a, b],
      fillColor,
      labelColor: "#ffffff",
    };
  };
  return [
    mk("스텝 타임 (s)", 44, 126, true),
    mk("캡처율 (%)", 26, 54, false),
    mk("Feed H2 %", 58, 102, true),
    mk("Feed CH4 %", 32, 74, false),
    mk("진공 압력", 46, 86, false),
    mk("사이클", 52, 120, true),
    mk("퍼지 압력 (kPa)", 36, 78, false),
    mk("배기 온도 (°C)", 40, 96, true),
  ];
}

function xaiTooltipHtml(w, seriesIndex, dataPointIndex) {
  const row = w.config.series[seriesIndex].data[dataPointIndex];
  if (!row || !Array.isArray(row.y)) {
    return "";
  }
  const title = row.x || "";
  const range = `${row.y[0]} ~ ${row.y[1]}`;
  return (
    '<div style="padding:10px 12px;background:#fff;border:1px solid #e4e7ed;border-radius:8px;box-shadow:0 4px 14px rgba(0,0,0,.08);min-width:168px">' +
    '<div style="font-weight:600;color:#303133;font-size:13px;margin-bottom:6px;line-height:1.35">' +
    title +
    "</div>" +
    '<div style="color:#606266;font-size:12px;line-height:1.4">구간: ' +
    range +
    "</div>" +
    "</div>"
  );
}

/** 라인별 고정 색 — 비중 내림차순으로 그릴 때도 라인 색은 동일하게 유지 */
const LINE_DONUT_LINES = [
  { label: "라인 A", color: PRIMARY },
  { label: "라인 B", color: PRIMARY_LIGHT },
  { label: "라인 C", color: "#e6a23c" },
];

/** 비중 큰 순(첫 조각이 12시 방향부터 가장 크게 보이도록 시리즈·라벨·색 정렬) */
function sortLineDonutByShare(values) {
  const tuples = values.map((value, i) => ({
    value,
    label: LINE_DONUT_LINES[i].label,
    color: LINE_DONUT_LINES[i].color,
  }));
  tuples.sort((a, b) => b.value - a.value);
  return {
    series: tuples.map((t) => t.value),
    labels: tuples.map((t) => t.label),
    colors: tuples.map((t) => t.color),
  };
}

function buildLots(seed, startStr, endStr) {
  const types = ["스크래치", "치수", "이물", "색상"];
  const lines = ["A", "B", "C"];
  const causes = ["재작업", "폐기", "검토 중", "공급사 통보"];
  const start = parseYmd(startStr);
  const end = parseYmd(endStr);
  const span = Math.max(0, Math.round((end - start) / 86400000));
  return Array.from({ length: 6 }, (_, i) => {
    const dayOffset = span > 0 ? (seed + i * 17) % (span + 1) : 0;
    const d = new Date(start);
    d.setDate(d.getDate() + dayOffset);
    const mo = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    const hh = String(8 + ((seed + i) % 9)).padStart(2, "0");
    const mm = String((20 + i * 7 + seed) % 60).padStart(2, "0");
    return {
      time: `${mo}.${day} ${hh}:${mm}`,
      line: lines[(seed + i) % 3],
      lot: `L-${202400 + ((seed + i * 11) % 900)}`,
      type: types[(seed + i) % types.length],
      qty: 1 + ((seed + i * 3) % 12),
      cause: causes[(seed + i) % causes.length],
    };
  });
}

export default {
  name: "FactoryQualityDashboard",
  data() {
    const periodRange = defaultPeriodRange();
    const seed = hashPeriod(periodRange[0], periodRange[1]);
    const dayCount = daysInclusive(periodRange[0], periodRange[1]);
    const dpmPct = (0.28 + (seed % 25) / 200).toFixed(2);
    const trend = buildTrend(seed, periodRange[0], dayCount);
    const xaiData = buildXaiData(seed);
    const lineDonut = sortLineDonutByShare([
      35 + (seed % 20),
      30 + (seed % 18),
      20 + (seed % 15),
    ]);
    const inspBase = 17000 + (seed % 3000);
    const inspScaled = Math.round((inspBase * dayCount) / 14);
    const claimScaled = Math.max(
      1,
      Math.round(((4 + (seed % 8)) * dayCount) / 14)
    );
    const basePareto = [128, 86, 54, 38, 22];
    const paretoData = basePareto.map((v) =>
      Math.max(8, Math.round(v + (seed % 40) - (seed % 25)))
    );
    return {
      chartRevision: 0,
      periodRange,
      periodPickerOptions: {
        shortcuts: [
          {
            text: "최근 7일",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setDate(end.getDate() - 6);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "최근 14일",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setDate(end.getDate() - 13);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "최근 30일",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setDate(end.getDate() - 29);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      kpis: [
        {
          key: "dpm",
          label: "공정 불량률 (기간 평균)",
          value: `${dpmPct}%`,
          meta:
            Number(dpmPct) <= 0.5
              ? `선택 ${dayCount}일 · 목표 0.50% 이하 · 양호`
              : `선택 ${dayCount}일 · 목표 0.50% 이하 · 주의`,
        },
        {
          key: "insp",
          label: "검사 완료 (기간)",
          value: `${inspScaled.toLocaleString()}건`,
          meta: "전일 대비",
        },
        {
          key: "claim",
          label: "클레임 접수 (기간)",
          value: `${claimScaled}건`,
          meta: "누적",
        },
        {
          key: "fty",
          label: "FTY (1차 합격)",
          value: `${(97.5 + (seed % 15) / 10).toFixed(1)}%`,
          meta: "목표 98.0% 이상",
        },
      ],
      paretoSeries: [
        {
          name: "건수",
          data: paretoData,
        },
      ],
      paretoOptions: {
        chart: {
          toolbar: { show: false },
          fontFamily: "Pretendard, sans-serif",
        },
        plotOptions: {
          bar: {
            horizontal: true,
            borderRadius: 4,
            barHeight: "62%",
            distributed: true,
          },
        },
        colors: [PRIMARY, PRIMARY_LIGHT, "#67c23a", "#e6a23c", "#909399"],
        dataLabels: {
          enabled: true,
          formatter: (v) => `${v}건`,
          style: { fontSize: "11px", colors: ["#303133"] },
        },
        xaxis: {
          categories: [...DEFECT_LABELS],
          labels: { style: { colors: MUTED } },
        },
        yaxis: {
          labels: { style: { colors: MUTED } },
        },
        grid: { borderColor: "#eef0f3" },
        legend: { show: false },
        tooltip: {
          theme: "light",
          fillSeriesColor: false,
          y: { formatter: (v) => `${v}건` },
        },
      },
      lineDonutSeries: lineDonut.series,
      lineDonutOptions: {
        chart: { fontFamily: "Pretendard, sans-serif" },
        labels: lineDonut.labels,
        colors: lineDonut.colors,
        legend: {
          position: "bottom",
          fontSize: "13px",
          labels: { colors: "#505258" },
        },
        plotOptions: {
          pie: {
            donut: {
              size: "68%",
              labels: {
                show: true,
                name: { show: true },
                value: {
                  show: true,
                  formatter: (val) =>
                    val != null && val !== "" ? `${val}%` : "",
                },
                total: {
                  show: false,
                },
              },
            },
          },
        },
        dataLabels: { enabled: false },
        tooltip: {
          theme: "light",
          fillSeriesColor: false,
          y: { formatter: (v) => `${v}%` },
        },
      },
      xaiSeries: [{ name: "기여 구간", data: xaiData }],
      xaiOptions: {
        chart: {
          type: "rangeBar",
          toolbar: { show: false },
          fontFamily: "Pretendard, sans-serif",
        },
        plotOptions: {
          bar: {
            horizontal: true,
            barHeight: "68%",
            rangeBarGroupRows: false,
            borderRadius: 4,
            dataLabels: {
              hideOverflowingLabels: false,
            },
          },
        },
        colors: [PRIMARY],
        fill: { opacity: 1 },
        dataLabels: {
          enabled: true,
          textAnchor: "middle",
          style: {
            fontSize: "11px",
            fontWeight: 600,
            colors: xaiData.map((d) => d.labelColor),
          },
          formatter(_val, opts) {
            const d =
              opts.w.config.series[opts.seriesIndex].data[opts.dataPointIndex];
            if (d && Array.isArray(d.y)) {
              return `${d.y[0]} → ${d.y[1]}`;
            }
            return "";
          },
        },
        xaxis: {
          type: "numeric",
          min: 15,
          max: 150,
          tickAmount: 6,
          labels: { style: { colors: MUTED, fontSize: "11px" } },
          title: {
            text: "기여 스코어",
            style: { color: MUTED, fontSize: "11px" },
          },
        },
        yaxis: {
          labels: {
            style: {
              colors: MUTED,
              fontSize: "11px",
              maxWidth: 280,
            },
          },
        },
        grid: {
          borderColor: "#eef0f3",
          xaxis: { lines: { show: true } },
          padding: { right: 12 },
        },
        tooltip: {
          theme: "light",
          fillSeriesColor: false,
          custom(opts) {
            return xaiTooltipHtml(
              opts.w,
              opts.seriesIndex,
              opts.dataPointIndex
            );
          },
        },
        legend: { show: false },
      },
      trendSeries: [{ name: "불량률 (%)", data: trend.data }],
      trendOptions: {
        chart: {
          toolbar: { show: false },
          fontFamily: "Pretendard, sans-serif",
        },
        colors: [PRIMARY],
        stroke: { curve: "smooth", width: 2 },
        fill: {
          type: "gradient",
          gradient: {
            shadeIntensity: 1,
            opacityFrom: 0.22,
            opacityTo: 0.02,
            stops: [0, 92, 100],
          },
        },
        dataLabels: { enabled: false },
        xaxis: {
          categories: trend.labels,
          labels: { style: { colors: MUTED, fontSize: "11px" } },
        },
        yaxis: {
          max: 1.2,
          decimalsInFloat: 2,
          labels: { style: { colors: MUTED } },
          title: {
            text: "%",
            style: { color: MUTED, fontSize: "11px" },
          },
        },
        grid: { borderColor: "#eef0f3", strokeDashArray: 4 },
        tooltip: {
          theme: "light",
          fillSeriesColor: false,
          y: { formatter: (v) => `${v}%` },
        },
      },
      lotRows: buildLots(seed, periodRange[0], periodRange[1]),
    };
  },
  computed: {
    trendPeriodHint() {
      if (!this.periodRange || this.periodRange.length !== 2) {
        return "";
      }
      const [a, b] = this.periodRange;
      const n = daysInclusive(a, b);
      return `${a.replace(/-/g, ".")} ~ ${b.replace(/-/g, ".")} · ${n}일`;
    },
  },
  methods: {
    onDemoExport() {
      this.$message.info("데모 환경에서는 내보내기를 지원하지 않습니다.");
    },
    applyQualityData(seed) {
      const [startStr, endStr] = this.periodRange || [];
      if (!startStr || !endStr) {
        return;
      }
      const dayCount = daysInclusive(startStr, endStr);
      const trend = buildTrend(seed, startStr, dayCount);
      const basePareto = [128, 86, 54, 38, 22];
      this.paretoSeries = [
        {
          name: "건수",
          data: basePareto.map((v) =>
            Math.max(8, Math.round(v + (seed % 40) - (seed % 25)))
          ),
        },
      ];
      const d = (0.28 + (seed % 25) / 200).toFixed(2);
      const inspBase = 17000 + (seed % 3000);
      const inspScaled = Math.round((inspBase * dayCount) / 14);
      const claimScaled = Math.max(
        1,
        Math.round(((4 + (seed % 8)) * dayCount) / 14)
      );
      this.kpis = [
        {
          key: "dpm",
          label: "공정 불량률 (기간 평균)",
          value: `${d}%`,
          meta:
            Number(d) <= 0.5
              ? `선택 ${dayCount}일 · 목표 0.50% 이하 · 양호`
              : `선택 ${dayCount}일 · 목표 0.50% 이하 · 주의`,
        },
        {
          key: "insp",
          label: "검사 완료 (기간)",
          value: `${inspScaled.toLocaleString()}건`,
          meta: "전일 대비",
        },
        {
          key: "claim",
          label: "클레임 접수 (기간)",
          value: `${claimScaled}건`,
          meta: "누적",
        },
        {
          key: "fty",
          label: "FTY (1차 합격)",
          value: `${(97.5 + (seed % 15) / 10).toFixed(1)}%`,
          meta: "목표 98.0% 이상",
        },
      ];
      const lineDonut = sortLineDonutByShare([
        35 + (seed % 20),
        30 + (seed % 18),
        20 + (seed % 15),
      ]);
      this.lineDonutSeries = lineDonut.series;
      this.lineDonutOptions = {
        ...this.lineDonutOptions,
        labels: lineDonut.labels,
        colors: lineDonut.colors,
      };
      const xd = buildXaiData(seed);
      this.xaiSeries = [{ name: "기여 구간", data: xd }];
      this.xaiOptions = {
        ...this.xaiOptions,
        dataLabels: {
          ...this.xaiOptions.dataLabels,
          style: {
            ...this.xaiOptions.dataLabels.style,
            colors: xd.map((row) => row.labelColor),
          },
        },
      };
      this.trendSeries = [{ name: "불량률 (%)", data: trend.data }];
      this.trendOptions = {
        ...this.trendOptions,
        xaxis: {
          ...this.trendOptions.xaxis,
          categories: trend.labels,
        },
      };
      this.lotRows = buildLots(seed, startStr, endStr);
    },
    onPeriodChange(val) {
      if (!val || val.length !== 2) {
        this.periodRange = defaultPeriodRange();
        this.$nextTick(() => {
          const s = hashPeriod(this.periodRange[0], this.periodRange[1]);
          this.applyQualityData(s);
          this.chartRevision += 1;
        });
        return;
      }
      const seed = hashPeriod(val[0], val[1]);
      this.applyQualityData(seed);
      this.chartRevision += 1;
    },
    onRefresh() {
      if (!this.periodRange || this.periodRange.length !== 2) {
        this.periodRange = defaultPeriodRange();
      }
      const base = hashPeriod(this.periodRange[0], this.periodRange[1]);
      const seed = (base + (Date.now() % 997)) % 997;
      this.applyQualityData(seed);
      this.chartRevision += 1;
      this.$message.success("품질 데이터를 갱신했습니다.");
    },
  },
};
</script>

<style lang="scss" scoped>
.fac-dash {
  width: 100%;
  padding: 24px 32px 48px;
  box-sizing: border-box;
  background: linear-gradient(180deg, #f4f6f8 0%, #fff 30%);
}

.fac-dash__page-head {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 16px;
  padding-bottom: 16px;
  border-bottom: 1px solid #ebeef5;
}

.fac-dash__page-head-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
}

.fac-dash__period {
  width: 260px;
  max-width: 100%;
}

.fac-dash__head-btn {
  flex-shrink: 0;
}

.fac-dash__refresh {
  flex-shrink: 0;
}

.fac-dash__page-title {
  margin: 0 0 6px;
  font-size: 22px;
  font-weight: 700;
  color: #303133;
  letter-spacing: -0.03em;
}

.fac-dash__page-sub {
  margin: 0;
  font-size: 13px;
  line-height: 1.55;
  color: #909399;
}

.fac-dash__kpis {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 14px;
  margin-bottom: 20px;
}

@media (max-width: 992px) {
  .fac-dash__kpis {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 480px) {
  .fac-dash__kpis {
    grid-template-columns: 1fr;
  }
}

.fac-dash__kpi-card {
  border-radius: 8px;
  border: 1px solid #ebeef5;
}

.fac-dash__kpi-label {
  margin: 0 0 6px;
  font-size: 12px;
  color: #909399;
}

.fac-dash__kpi-value {
  margin: 0 0 4px;
  font-size: 19px;
  font-weight: 700;
  color: #303133;
  letter-spacing: -0.02em;
}

.fac-dash__kpi-meta {
  margin: 0;
  font-size: 11px;
  color: #67c23a;
}

.fac-dash__row {
  margin-bottom: 20px !important;
}

@media (max-width: 1199px) {
  .fac-dash__row > .el-col:not(:last-child) {
    margin-bottom: 20px;
  }
}

.fac-dash__chart-card {
  border-radius: 8px;
  border: 1px solid #ebeef5;
  margin-bottom: 0;
}

.fac-dash__card-head {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 8px;
  font-size: 15px;
  font-weight: 600;
  color: #303133;
}

.fac-dash__card-head-meta {
  font-size: 12px;
  font-weight: 500;
  color: #909399;
}

.fac-dash__xai-legend {
  margin: 0 0 12px;
  padding: 0 4px;
  font-size: 12px;
  color: #606266;
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}

.fac-dash__xai-legend-item {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.fac-dash__xai-dot {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 2px;
  flex-shrink: 0;
}

.fac-dash__xai-dot.is-up {
  background: #e85d6f;
}

.fac-dash__xai-dot.is-down {
  background: #254aa5;
}

.fac-dash__table {
  width: 100%;
}

/* Apex 툴팁 DOM이 차트 간 재사용되며 시리즈 색에 맞춘 흰 글자가 남는 경우가 있어 고정 */
.fac-dash ::v-deep .apexcharts-tooltip,
.fac-dash ::v-deep .apexcharts-tooltip-title,
.fac-dash ::v-deep .apexcharts-tooltip-text,
.fac-dash ::v-deep .apexcharts-tooltip-text-y-label,
.fac-dash ::v-deep .apexcharts-tooltip-text-y-value {
  color: #303133 !important;
}
</style>
